export default {
  title: "Dashboard",
  subtitle: "Your personal dashboard",
  collections: {
    title: "Collections",
    subtitle: "Learning paths and {{mainEntityLabelLower}} collections"
  },
  courses: {
    title: "{{mainEntityLabelPlural}}",
    subtitle: "{{mainEntityLabelPlural}} you are enrolled in",
    columns: {
      title: "{{mainEntityLabel}} title",
      instructor: "Instructor",
      level: "Level",
      progress: "Progress",
      lastAccessed: "Last accessed",
      enrollmentDate: "Enrolled",
      actions: "Actions"
    },
    empty: {
      title: "No {{mainEntityLabelPluralLower}} found",
      description: "You are not enrolled in any {{mainEntityLabelPluralLower}} yet."
    }
  },
  templates: {
    title: "{{mainEntityLabel}} templates",
    subtitle: "Available {{mainEntityLabelLower}} templates to create instances from",
    columns: {
      title: "Template title",
      category: "Category",
      level: "Level",
      instances: "Instances",
      published: "Published",
      lastModified: "Last modified",
      actions: "Actions"
    },
    empty: {
      title: "No templates found",
      description: "There are no {{mainEntityLabelLower}} templates available."
    }
  },
  instances: {
    title: "{{mainEntityLabel}} instances",
    subtitle: "Active {{mainEntityLabelLower}} instances",
    columns: {
      title: "Instance title",
      template: "Template",
      owner: "Owner",
      progress: "Progress",
      createdDate: "Created",
      lastAccessed: "Last accessed",
      actions: "Actions"
    },
    empty: {
      title: "No instances found",
      description: "There are no {{mainEntityLabelLower}} instances available."
    }
  },
  topics: {
    title: "My topics",
    subtitle: "Topics from your enrolled {{mainEntityLabelPluralLower}}",
    columns: {
      title: "Topic title",
      course: "{{mainEntityLabel}}",
      module: "Module",
      progress: "Progress",
      bookmarked: "Bookmarked",
      lastAccessed: "Last accessed",
      actions: "Actions"
    },
    empty: {
      title: "No topics found",
      description: "There are no topics available."
    }
  }
}
